import { defineStore } from 'pinia'
import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'
import type { InternalComment } from '@/types/userProfile'

const pageSize = 20

export const useInternalCommentsStore = defineStore('internalComments', {
  state: () => ({
    comments: [] as InternalComment[],
    loading: false,
    error: null as string | null,
    pagination: {
      totalPages: 1,
      currentPage: 1
    },
    filters: {
      type: 'all',
      search: ''
    },
    totalCount: 0
  }),

  getters: {
    hasComments: (state) => state.comments.length > 0,
    isPaginated: (state) => state.pagination.totalPages > 1
  },

  actions: {
    async fetchComments({ page = 1 } = {}) {
      this.loading = true
      this.error = null
      try {
        const params: Record<string, any> = { page, page_size: pageSize }
        
        // Add type filter
        if (this.filters.type !== 'all') {
          params.type = this.filters.type
        }
        
        // Add search if present
        if (this.filters.search) {
          params.search = this.filters.search
        }

        const response = await api.get(API_ROUTES.GET_INTERNAL_COMMENTS, { params })
        this.comments = response.data.results
        this.totalCount = response.data.count
        this.pagination = {
          totalPages: Math.ceil(response.data.count / pageSize),
          currentPage: page
        }
      } catch (error) {
        console.error('Error fetching internal comments:', error)
        this.error = 'Failed to fetch internal comments'
      } finally {
        this.loading = false
      }
    },

    setFilter(type: 'all' | 'reports' | 'strikes') {
      this.filters.type = type
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.fetchComments({ page: 1 }) // Reset to first page when filter changes
    },

    setSearch(search: string) {
      this.filters.search = search
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.fetchComments({ page: 1 }) // Reset to first page when search changes
    }
  }
})